"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _DataTableRow = _interopRequireDefault(require("./DataTableRow"));
var _TableModule = _interopRequireDefault(require("../Table.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataTable = function DataTable(_ref) {
  var tableRowsProps = _ref.tableRowsProps,
    columns = _ref.columns,
    title = _ref.title;
  // In Safari the table's CSS does not update as rows are hidden/shown.
  // To work around this, we set the key to force a re-render.
  // https://github.com/facebook/react/issues/26713
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
    "aria-label": "".concat(title, " table"),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("thead", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
        className: _TableModule["default"].topRow,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("td", {}), columns.map(function (column, index) {
          var _column$image, _column$image2;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
            scope: "col",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: ((_column$image = column.image) === null || _column$image === void 0 ? void 0 : _column$image.desktop) || '',
              alt: ((_column$image2 = column.image) === null || _column$image2 === void 0 ? void 0 : _column$image2.altText) || '',
              className: _TableModule["default"].columnImage
            })
          }, index);
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
          scope: "col",
          className: _TableModule["default"].title,
          children: "Maximum we'll pay for:"
        }), ['Bronze', 'Silver', 'Gold'].map(function (tier, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("th", {
            scope: "col",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _TableModule["default"].tierText,
              children: tier
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: index === 0 ? _TableModule["default"].bronzeBottom : index === 1 ? _TableModule["default"].silverBottom : _TableModule["default"].goldBottom
            })]
          }, index);
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
      children: tableRowsProps.map(function (rowProps, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTableRow["default"], {
          value0: rowProps.value0,
          copy: rowProps.copy,
          columns: rowProps.columns
        }, index);
      })
    })]
  }, "rows-".concat(tableRowsProps.length));
};
var _default = exports["default"] = DataTable;